import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { ReporteriaService } from '../../../../core/services/http/reporteria/reporteria.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() titleHeader: string;
  @Input() imgHeader: string;
  @Input() modulo: string;
  nombreCliente: string;
  sexoCliente: string;

  constructor(
    private authService: AuthService,
    private reporteriaService: ReporteriaService
  ) {
    this.authService.idleUser();
  }

  ngOnInit() {
    this.getDataClient();
  }

  exit(e: any) {
    this.moduloSeleccionado();
    this.reporteUsabilidad('Cerrar sesión', 'Cierre de sesión de usuario', true);
    e.preventDefault();
    this.authService.logout();
  }

  async getDataClient() {
    const rutCliente = localStorage.getItem('cbRutCliente');
    const response = await this.authService.leerCliente(rutCliente);
    if (response['status']) {
      this.sexoCliente = response['data']['datosCliente']['sexo'];
      this.sexoCliente = this.sexoCliente === 'M' ? 'Bienvenido' : 'Bienvenida';
    }
    this.nombreCliente = localStorage.getItem('cbNombre');
  }

  moduloSeleccionado() {
    if (this.modulo === 'venta-bonos') {
      this.modulo = 'Compra de bonos';
    }
    if (this.modulo === 'reembolso') {
      this.modulo = 'Reembolso';
    }
    if (this.modulo === 'cotizaciones') {
      this.modulo = 'Pago de cotizaciones';
    }
    if (this.modulo === 'certificados') {
      this.modulo = 'Certificados';
    }
    if (this.modulo === 'devolucion') {
      this.modulo = 'Devolución de excesos';
    }
    if (this.modulo === 'pagobonos') {
      this.modulo = 'Pago de bonos emitidos';
    }
    if (this.modulo === 'licencias') {
      this.modulo = 'Licencias';
    }
    if (this.modulo === 'menu') {
      this.modulo = 'Menú';
    }
  }

  reporteUsabilidad(recurso: string, respuesta: string, status: boolean) {
    const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');

    this.reporteriaService.saveLog(
      this.modulo,
      recurso,
      respuesta,
      'Front-End',
      status,
      rut
    );
  }
}
